import { Vector2Tuple, Vector3Tuple } from 'three';

import { CameraPathShallowNode } from '@spazious/dollhouse-shallow-graph';

import { CameraPathNode, FNodeTypesEnum } from '../types/index.js';

import { BaseNodeImpl } from './BaseNode.js';

export class CameraPathNodeImpl extends BaseNodeImpl implements CameraPathNode {
  type: FNodeTypesEnum.CameraPath = FNodeTypesEnum.CameraPath;
  shallow: CameraPathShallowNode | null = null;
  points: [Vector3Tuple, Vector3Tuple][] = [];
  position: Vector2Tuple = [0, 0];
  rotation: number = 0;
  visible: boolean = true;
  toJSON(recursive?: boolean) {
    return {
      ...super.toJSON(recursive),
      position: this.position,
      rotation: this.rotation,
      visible: this.visible,
      shallow: this.shallow,
      points: this.points,
    };
  }
}
